import { Component } from '@angular/core';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-rules',
  templateUrl: 'rules.html',
})
export class RulesPage {

  public content: string;

  constructor(public viewCtrl: ViewController, navParams: NavParams) {
    this.content = navParams.get('content');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {}

}



// WEBPACK FOOTER //
// ./src/pages/rules/rules.ts